import type {
  NotificationReadCreateRequestType,
  NotificationReadCreateResponseType,
} from "@sellar-io/api-v2/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useNotificationReadCreate = () => {
  const queryClient = useQueryClient();
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: (data: NotificationReadCreateRequestType) =>
      apiV2Request({
        user,
        business,
        method: "post",
        path: `notification-read`,
        data,
      }).then(
        (data) =>
          apiV2AssertResponse(data).data as NotificationReadCreateResponseType,
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [user?.uid, business?.id, ServerStateKeys.Notifications],
      });
    },
  });
};
